// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-numbers-container {
  width: 100%;
}

.table-numbers-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.table-number-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  font-size: 14px;
  border-radius: 16px;
  background-color: var(--undp-jtf-btn-dark-color);
  color: white;
}
.table-number-chip .close-chip {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 0;
  margin-left: 4px;
  font-size: 16px;
  line-height: 1;
  opacity: 0.8;
  transition: opacity 0.2s;
}
.table-number-chip .close-chip:hover {
  opacity: 1;
}

.input-group .btn {
  display: flex;
  align-items: center;
  gap: 4px;
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/shared/post-editor/table-numbers-input/table-numbers-input.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,gDAAA;EACA,YAAA;AACF;AACE;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,wBAAA;AACJ;AACI;EACE,UAAA;AACN;;AAKE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAFJ","sourcesContent":[".table-numbers-container {\n  width: 100%;\n}\n\n.table-numbers-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.table-number-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  font-size: 14px;\n  border-radius: 16px;\n  background-color: var(--undp-jtf-btn-dark-color);\n  color: white;\n  \n  .close-chip {\n    background: none;\n    border: none;\n    color: white;\n    cursor: pointer;\n    padding: 0;\n    margin-left: 4px;\n    font-size: 16px;\n    line-height: 1;\n    opacity: 0.8;\n    transition: opacity 0.2s;\n    \n    &:hover {\n      opacity: 1;\n    }\n  }\n}\n\n.input-group {\n  .btn {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
